import { Component, Input } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    standalone: true,
    imports: [IonicModule, TranslateModule],
    selector: "accode-document-modal",
    templateUrl: "./accode-document-modal.component.html",
    styleUrls: ["./accode-document-modal.component.scss"]
})
export class AccodeDocumentModalComponent {
    @Input() callback: any;
    @Input() accodeById: number;

    approve() {
        this.callback();
    }
}
